// extracted by mini-css-extract-plugin
export var markdown = "index-module--markdown--RI+u5";